import { ModuleFilteredQuestions } from '@protos/learning_management/lms.assessment.teacher.apis_pb';

// ------------------------------------------------------------

export const createChapterList = (
  initialData: ModuleFilteredQuestions | undefined
) => {
  return (
    initialData?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo.map((data) => {
      return {
        name: `${data.chapterNo}. ${data.name}`,
        id: data.chapterId,
        checked: true,
      };
    }) || []
  );
};

// ------------------------------------------------------------

// Every topic for the assessment — UI always shows the full list (not filtered by chapter).
export const createAllTopicList = (
  initialData: ModuleFilteredQuestions | undefined
) => {
  if (!initialData) return [];

  return (
    initialData?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo?.flatMap(
      (chapter) =>
        chapter.topicInfo?.map((topic) => ({
          name: topic.name,
          id: topic.topicId,
          checked: true,
        })) || []
    ) || []
  );
};

// ------------------------------------------------------------

// Lookup used to sync chapter ↔ topic selection (e.g. auto-select chapter when a topic is checked).
export const getTopicIdToChapterIdMap = (
  initialData: ModuleFilteredQuestions | undefined
) => {
  const topicIdToChapterId = new Map<number, number>();
  initialData?.taskMetaInfo?.chapterInfo?.chapterTopicsInfo?.forEach(
    (chapter) => {
      chapter.topicInfo?.forEach((topic) => {
        topicIdToChapterId.set(topic.topicId, chapter.chapterId);
      });
    }
  );
  return topicIdToChapterId;
};

// ------------------------------------------------------------
